<template>
  <div class="home">
    <MyHeader title="home" :showBack="false"></MyHeader>
    <div class="content">
      <div class="left">
        <el-carousel height="100%" :autoplay="false" style="width: 100%" arrow="never"
                     @change="carouselChange()">
          <el-carousel-item autoplay="false">
            <div v-if="carouselFirstShow">
              <EconomicEntities ref="EconomicEntities" :yearP="year" :selectListP="selectList" style="margin-left: auto;margin-right: auto"/>
              <PrivateEnterprise ref="PrivateEnterprise" :yearP="year" style="margin-left: auto;margin-right: auto"/>
              <Top500 ref="Top500" :yearP="year" :selectListP="selectList" style="margin-left: auto;margin-right: auto"/>
            </div>
          </el-carousel-item>
          <el-carousel-item autoplay="false">
            <div v-if="!carouselFirstShow">
              <CompanyTop100 ref="CompanyTop100" :yearP="year" :selectListP="selectList"  style="margin-left: auto;margin-right: auto"/>
              <ChartBar ref="barHighTech" name="highTech" title="广东省高新企业" apiName="getHighTech" :yearP="year"  style="margin-left: auto;margin-right: auto"/>
              <ChartBar
                  ref="barSpecialNew"
                  @click-chart="handleClickChart($event, '广东省专精特新企业')"
                  chartId="chart-special-new"
                  type="multi"
                  name="specialNew"
                  title="广东省专精特新企业"
                  apiName="getSpecialNewEnterprise"
                  :yearP="year"
                  style="margin-left: auto;margin-right: auto"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="center">
        <TopCount ref="TopCount" :type="mapCode > 1 ? 'Guangdong' : 'Country'" :pointName="mapName"></TopCount>
        <AMap @mapCode="changeMapCode" @loading="(e) => (loading = e)"></AMap>
      </div>
      <div class="right">
        <el-carousel height="100%" :autoplay="false" style="width: 100%" arrow="never"
                     @change="carouselTwoChange()">
          <el-carousel-item autoplay="false">
            <div v-if="carouselTwoFirstShow">
              <GDPAndGrowthRate ref="GDPAndGrowthRate" :yearP="year"  style="margin-left: auto;margin-right: auto"/>
              <EconomicProductionPavilion ref="EconomicProductionPavilion" :yearP="year" :selectListP="selectList"  style="margin-left: auto;margin-right: auto"/>
              <!--<Chart3D />-->
              <FixedAssetInvestment ref="FixedAssetInvestment" :yearP="year"  style="margin-left: auto;margin-right: auto"/>
            </div>
          </el-carousel-item>
          <el-carousel-item autoplay="false">
            <div v-if="!carouselTwoFirstShow">
              <EconomicVolume ref="EconomicVolume" :yearP="year"  style="margin-left: auto;margin-right: auto"/>
              <ChartBar
                  ref="barPrivateTax"
                  title="广东省民营税金"
                  name="privateTax"
                  apiName="getPrivateTax"
                  type="multi"
                  showLabel
                  :yearP="year"
                  style="margin-left: auto;margin-right: auto"
              />
              <ChartBar
                  ref="barBankFinance"
                  title="民营企业金融服务情况"
                  name="bankFinance"
                  apiName="getCooperativeBank"
                  type="multi"
                  :yearP="year"
                  style="margin-left: auto;margin-right: auto"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!--<div class="login-wrap" v-if="!isLogin">-->
    <!--  <div class="login-box">-->
    <!--    <span>请输入密码：</span>-->
    <!--    <div class="password">-->
    <!--      <el-input v-model="pass"-->
    <!--                type="password"-->
    <!--                @keyup.enter.native="submit"-->
    <!--                show-password />-->
    <!--      <el-button @click="submit">提交</el-button>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <EleDialog :title="dialogTitle" :visible.sync="showDialog">
      <div class="filter-box">
        <ElementSelect
          :val="search.cityName"
          :options="optionCity"
          clearable
          @val="changeVal($event, 'cityName')"
          v-if="!apiName.includes('City')"
          size="middle"
        />
        <ElementSelect
          :val="search.year"
          :options="eYearList"
          clearable
          @val="changeVal($event, 'year')"
          v-else
          size="middle"
        />
        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" />
      </div>
      <ComTable
        :tableCol="tableCol"
        :tableData="tableData"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>
    <!--<div class="loading" v-loading="loading" v-if="loading"-->
    <!--     element-loading-background="rgba(0, 0, 0, 0)">-->
    <!--</div>-->
  </div>
</template>

<script>
import { getTime } from '@/utils';
import AMap from './comp/AMap';
import TopCount from './comp/TopCount';
import EconomicEntities from './comp/EconomicEntities';
import PrivateEnterprise from './comp/PrivateEnterprise';
import Top500 from './comp/Top500';
import CompanyTop100 from './comp/CompanyTop100';
import ChartBar from './comp/ChartBar';
import GDPAndGrowthRate from './comp/GDP-and-growth-rate';
import FixedAssetInvestment from './comp/fixed-asset-investment';
import EconomicVolume from './comp/economic-volume';
import EconomicProductionPavilion from './comp/economic-production-pavilion';
import Chart3D from './comp/Chart3D';
import ComTable from '../../components/ComTable';
import ElementSelect from '../../components/element-select';
import cityJson from './cityJson';
import MyHeader from '@/components/Header';
import DisaggregatedStatistical from "@/views/home/comp/DisaggregatedStatistical";

export default {
  name: 'Home',
  components: {
    DisaggregatedStatistical,
    MyHeader,
    ElementSelect,
    ComTable,
    Chart3D,
    EconomicProductionPavilion,
    EconomicVolume,
    FixedAssetInvestment,
    GDPAndGrowthRate,
    ChartBar,
    CompanyTop100,
    Top500,
    PrivateEnterprise,
    EconomicEntities,
    TopCount,
    AMap,
  },
  data() {
    return {

      eYearList: [],
      eYearOption: [],
      carouselFirstShow: true,
      carouselTwoFirstShow: true,
      year: 2024,
      selectList: [],
      isLogin: true,
      pass: '',
      // currentTime: getTime(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      timer: null,
      mapCode: 1,
      mapName: '',
      loading: false,
      showDialog: false,
      dialogTitle: '',
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 22,
      },
      apiName: '',
      search: {
        cityName: '',
        year: 0,
        enterpriseName: '',
      },
      optionCity: cityJson,
      optionYear: [
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
      ],
    };
  },
  computed: {
    tableCol() {
      let col = [];
      switch (this.apiName) {
        case 'getSpecialNewEnterpriseList':
        case 'getLitterEnterpriseList':
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'cityName',
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 320,
              align: 'left',
            },
          ];
          break;
        case 'getMapCityEnList':
          col = [
            {
              label: '排行',
              param: 'ranking',
              maxWidth: 70,
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 300,
              align: 'left',
            },
            {
              label: '所属行业',
              param: 'industry',
              width: 160,
              align: 'left',
            },
            {
              label: '营收（万元）',
              param: 'businessIncome',
              width: 80,
              align: 'left',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  created() {
    this.year = new Date().getFullYear();
    this.selectList = [
      {
        value: this.year,
        label: this.year,
      },
    ];
    while (this.selectList.slice(-1)[0].value > 2021) {
      let tmp = this.selectList.slice(-1)[0];
      this.selectList.push({
        value: tmp.value - 1,
        lable: tmp.value - 1,
      });
    }
    console.log(this.selectList);
    this.$api.market.getTyYearOption({dataType: 'tj_country_top_500_private_enterprises'}).then((res) => {
      this.eYearOption = res.data.data.data;
      // console.log("yearE", this.yearE)
      if (this.search.year === 0) {
        this.search.year = this.eYearOption[0];
        this.eYearList = []
        for (let key in this.eYearOption) {
          this.eYearList.push(
                  {
                    value: this.eYearOption[key],
                    lable: this.eYearOption[key],
                  }
          );
        }
        // console.log("this.eYearList",this.eYearList)
      }
    });
  },
  watch: {
    mapCode(n) {
      console.log(n, '-mapCode-n');
    },
    isLogin(n) {
      if (n) {
        // let expiredTime = sessionStorage.getItem('expiredTime'),
        //   nowStamp = new Date().getTime(),
        //   lessHour = expiredTime - nowStamp < 1000 * 60 * 60;
        // // if (lessHour) {
        //   setTimeout(() => {
        //     console.log(expiredTime - nowStamp, new Date(), expiredTime, nowStamp, '-in-expiredTime - nowStamp')
        //     this.$message.warning('登录超时，请重新登录！');
        //     sessionStorage.removeItem('expiredTime');
        //     this.isLogin = false;
        //   }, expiredTime - nowStamp)
        // // }
      }
    },
    'search.enterpriseName'(n) {
      this.getData();
    },
  },
  mounted() {
    // this.timer =  setInterval(() => {
    //     this.currentTime = getTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
    //   }, 1000);
    this.busOn();
    this.setTimer();

    // let expiredTime = sessionStorage.getItem('expiredTime');
    // let nowStamp = new Date().getTime();
    // if (expiredTime && nowStamp < expiredTime) {
    //   this.isLogin = true;
    // }

    window.onresize = () => {
      this.resizeChart();
    };
  },
  methods: {
    carouselChange() {
      this.carouselFirstShow = !this.carouselFirstShow;
    },
    carouselTwoChange() {
      this.carouselTwoFirstShow = !this.carouselTwoFirstShow;
    },
    clearSearch() {
      this.pager.pageSize = 10;
      this.pager.currentPage = 1;
      this.search = {
        enterpriseName: '',
        provinceName: '',
        cityName: '',
        year: '',
      };
    },
    busOn() {
      this.$bus.$on('showEn500Dialog', (data) => {
        this.dialogTitle =
          data.name + `${data.name.includes('省') || data.name.length > 2 ? '' : '市'}全国民营企业500强名单`;
        this.clearSearch();
        let params = {
          cityName: data.name,
          year: data.year,
        };
        if (data.type === 1) {
          delete params.cityName;
          params.provinceName = data.name;
        }
        this.search = {
          ...this.search,
          ...params,
        };
        this.getData('500强', params);
      });
    },
    handleClickChart(params, name) {
      console.log(params, name, 'pp');
      this.dialogTitle = `${params.name}年${name}${params.seriesName}名单`;
      this.clearSearch();
      this.search.year = params.name;
      this.getData(name, this.search);
      this.show = true;
    },
    changeVal(e, type) {
      this.search[type] = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.getData();
    },
    changeMapCode(e) {
      this.mapCode = e.code;
      this.mapName = e?.name;
      console.log(e, '-e');
    },
    submit() {
      if (this.pass) {
        if (this.pass !== 'sgsl2022') {
          this.$message.info('密码错误，请重新输入！');
        } else {
          this.isLogin = true;
          let expiredTime = new Date().getTime() + 1000 * 60 * 60 * 12;
          sessionStorage.setItem('expiredTime', expiredTime);
        }
      } else {
        this.$message.info('请输入密码！');
      }
    },
    setTimer() {
      this.timer1 = setInterval(() => {
        this.$nextTick(() => {
          let chartBox = [
            'PrivateEnterprise',
            'barHighTech',
            'barSpecialNew',
            'GDPAndGrowthRate',
            'FixedAssetInvestment',
            'EconomicVolume',
            'EconomicProductionPavilion',
            'barPrivateTax',
            'barBankFinance',
          ];
          let i = 0;
          chartBox.map((item) => {
            setTimeout(() => {
              // this.$refs[item].setInterData();
            }, i * 100);
            i++;
          });
        });
      }, 5000);
    },
    resizeChart() {
      let chartBox = [
        'PrivateEnterprise',
        'barHighTech',
        'barSpecialNew',
        'GDPAndGrowthRate',
        'FixedAssetInvestment',
        'EconomicVolume',
        'EconomicProductionPavilion',
        'barPrivateTax',
        'barBankFinance',
      ];
      chartBox.map((item) => {
        for (let key in this.$refs[item].$refs) {
          this.$refs[item].$refs[key].resize();
        }
      });
    },
    getData(name, params) {
      let apiName = this.apiName;
      !name ? (name = this.dialogTitle) : '';
      if (this.dialogTitle.includes('企业中小')) {
        apiName = 'getSpecialNewEnterpriseList';
      }
      if (this.dialogTitle.includes('企业小巨人')) {
        apiName = 'getLitterEnterpriseList';
      }
      if (this.dialogTitle.includes('500强')) {
        apiName = 'getMapCityEnList';
      }
      this.apiName = apiName;
      params = {
        ...params,
        ...this.search,
        pageSize: this.pager.pageSize,
        pageNum: this.pager.currentPage,
      };
      this.search = {
        ...params,
      };
      if (!apiName) return;
      this.$api.screen[apiName](params).then((res) => {
        let { data } = res.data;
        this.tableData = data.records;
        this.pager.total = data.total;
        this.showDialog = true;
      });
    },
  },
  beforeDestroy() {
    this.$bus.$off('showEn500Dialog');
    // sessionStorage.removeItem('expiredTime');
    // clearInterval(this.timer)
    // clearSetInterval(this.timer1)
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: Digital;
  src: url('../../assets/unicode.digital.ttf');
}

/deep/.el-carousel--horizontal{
  overflow-x: unset;
}

/deep/.el-carousel__arrow {
  font-size: 30px;
}

/deep/.el-carousel__item.is-active {
  //z-index: 12;
  overflow: unset;
}

.home {
  /*width: 100%;*/
  width: 3200px;
  height: 1900px;
  /*background: #08090e url('../../assets/home/header.gif') no-repeat;*/
  background: url('~img/home/home-bg.jpg') no-repeat;
  background-size: 145%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  .time {
    position: absolute;
    top: 50px;
    right: 30px;

    img {
      width: 10px;
      margin-right: 5px;
    }

    span {
      font-family: Digital;
      color: #a2d0f4;
      font-size: 12px;
    }
  }
}

.content {
  display: flex;
  justify-content: space-around;
  padding: 0 15px;
  /*margin-top: 90px;*/
  // margin-top: 20px;
  height: calc(100vh - 135px);
  z-index: 11;

  .center {
    width: 39%;
    //height: calc(100% - 180px);
    position: relative;
    z-index: 1;

    .top-count {
      //width: calc(100% - 200px);
      margin: auto;
      position: relative;
      z-index: 11;
    }

    .aMap {
      //width: calc(100% - 100px);
      position: absolute;
      top: 110px;
      //left: 60px;
      /*top: 250px;*/
    }

    /*width: 59%;*/
    //  border:1px solid #333;
  }

  .left,
  .right {
    position: relative;
    display: flex;
    // z-index: 2;
    // width: 20%;
    // border:1px solid #333;

    > div:first-child {
      //margin-right: 30px;
    }
  }

  .left {
    width: 30%;
  }

  .right {
    width: 30%;
  }
}

/deep/.ele-dialog {
  .filter-box {
    margin-bottom: 20px;
    .flex-center();
    justify-content: flex-end;

    > div {
      margin-left: 20px;
    }
  }

  .com-table {
    height: calc(100% - 60px);
  }
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .flex-center();
  justify-content: center;

  .login-box {
    width: 620px;
    height: 220px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 0 4px 0 rgba(235, 235, 235, 0.2);
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    > span {
      color: #fff;
      font-size: 26px;
      text-align: left;
      line-height: 60px;
      margin-top: -10px;
    }
  }

  .password {
    width: 100%;
    .flex-center();
    margin-bottom: 20px;

    /deep/ .el-input {
      width: 85%;
      height: 56px;

      .el-input__inner {
        height: 100% !important;
      }

      .el-input__suffix {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .el-button {
      margin-left: 20px;
      width: 100px;
      height: 56px;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  /*filter: blur(10px);*/
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
</style>
